<template>
  <b-card
    :id="pillar.id"
    class="pillar"
    :class="verticalCenter ? 'vertical-center' : ''"
    :style="{ minHeight: height }"
  >
    <div>
      <div class="title">
        <div>
          <h4>
            <router-link :to="'/reports/gender-gap/' + pillar.id">
              {{ $t(pillar.name) }}
            </router-link>
          </h4>
          <h3>
            <router-link :to="'/reports/gender-gap/' + pillar.id">
              <span
                :class="
                  getColorStateIndex(
                    pillar.index,
                    pillar.errorOnAllIndexIndicators
                  )
                "
                >{{ $t(pillar.acronym) }} ({{
                  pillar.index | currency("", 0, { thousandsSeparator: "" })
                }}%)</span
              >
            </router-link>
          </h3>
        </div>
      </div>
      <div :class="pillar.id + alias" class="pillar-svg" />
    </div>
  </b-card>
</template>

<script>
import { mapGetters } from "vuex";
import { RadarChart } from "@/utils/RadarChart";

export default {
  name: "CardChartRadar",
  props: {
    pillarId: {
      type: String,
      default: "PP",
    },
    alias: {
      type: String,
      default: "alias",
    },
    height: {
      type: String,
      default: "auto",
    },
    verticalCenter: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      pillar: {},
    };
  },
  computed: mapGetters(["reportStatus", "pillarData", "getColorStateIndex"]),
  mounted() {
    var svg1 = this.$d3.select("#" + this.pillar.id);
    svg1.selectAll(".node").remove();
    this.pillar = this.pillarData(this.pillarId);
    this.drawRadarChart("." + this.pillar.id + this.alias, [
      this.pillar.children,
    ]);
    this.$store.watch(this.$store.getters.pillarsData, () => {
      this.pillar = this.pillarData(this.pillarId);
      var svg1 = this.$d3.select("#" + this.pillar.id);
      svg1.selectAll(".node").remove();
      this.drawRadarChart("." + this.pillar.id + this.alias, [
        this.pillar.children,
      ]);
    });
  },
  created() {
    var svg1 = this.$d3.select("#" + this.pillar.id);
    svg1.selectAll(".node").remove();
    this.pillar = this.pillarData(this.pillarId);
    this.drawRadarChart("." + this.pillar.id + this.alias, [
      this.pillar.children,
    ]);
  },
  updated() {
    var svg1 = this.$d3.select("#" + this.pillar.id);
    svg1.selectAll(".node").remove();
    this.drawRadarChart("." + this.pillar.id + this.alias, [
      this.pillar.children,
    ]);
  },

  methods: {
    drawRadarChart(chartName, data) {
      var element = this.$d3.select(".pillar-svg").node();
      var width = element?.getBoundingClientRect().width;
      if (width > 360) {
        width = 360;
      }
      var color = this.$d3.scaleOrdinal().range(["#676767", "#5e495f"]);
      var radarChartOptions = {
        w: width,
        h: width,
        color: color,
      };
      // Call function to draw the Radar chart
      RadarChart(chartName, data, this.pillarId, radarChartOptions);
    },
  },
  /*  watch: {
    pillarId: function (newVal, oldVal) {
      this.pillar = this.pillarData(this.pillarId)
      var svg1 = this.$d3.select('#' + this.pillar.id)
      svg1.selectAll('.node').remove()
      this.drawRadarChart('.' + this.pillar.id + this.alias, [this.pillar.children])
    }
  }*/
};
</script>

<style lang="sass" scoped>
/* components/cards/CardChartRadar */
.pillar
  text-align: center
  h4, h3
    text-transform: uppercase
    font-size: 1.3rem
    width: 100%
  h3 span
    padding: 0px 17px
    border-radius: 10px
  a
    text-decoration: none
    color: #000
  .title
    display: flex
    align-items: center
    height: 5.5rem
    justify-content: center
</style>
